import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://api-inventory.neuromotion.tech/api/v1/product';

export const getProduct = createAsyncThunk(
  'product/getProduct',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getSingleProduct = createAsyncThunk(
  'product/getSingleProduct',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const addProduct = createAsyncThunk(
  'product/addProduct',
  async (formData, { rejectWithValue }) => {
    try {
      console.log(formData)
      const response = await axios.post(`${API_URL}/add`, formData,
        {
            headers: {
              'Content-Type': 'multipart/form-data', // Set content type for file uploads
            },
          }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updateProduct = createAsyncThunk(
  'product/updateProduct',
  async (formData, { rejectWithValue }) => {
    try {
      console.log(formData)
      const response = await axios.put(`${API_URL}/update`, formData,
        {
            headers: {
              'Content-Type': 'multipart/form-data', 
            },
          }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const deleteProduct = createAsyncThunk(
  'product/deleteProduct',
  async (deletedID, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}/${deletedID}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const productSlice = createSlice({
  name: 'product',
  initialState: {
    allproducts:null,
    singleproduct:null,
    loading: false,
    error: null,
    message: false
  },
  reducers: {
       clearError: (state) => {
        state.error = null;
      },
      clearMessage: (state) => {
        state.message = null;
      }
  },
  extraReducers: (builder) => {
    builder.addCase(addProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addProduct.fulfilled, (state) => {
      state.loading = false;
      state.message = "Product Add Successfuly";
    });
    builder.addCase(addProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
    builder.addCase(getProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProduct.fulfilled, (state, action) => {
      state.loading = false;
      state.allproducts = action.payload.allproducts;
    });
    builder.addCase(getProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
    builder.addCase(getSingleProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleProduct.fulfilled, (state, action) => {
      state.loading = false;
      state.singleproduct = action.payload.singleproduct;
    });
    builder.addCase(getSingleProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
    builder.addCase(deleteProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteProduct.fulfilled, (state, action) => {
      state.loading = false;
      state.message = "Product delete successfuly";
    });
    builder.addCase(deleteProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
    builder.addCase(updateProduct.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateProduct.fulfilled, (state, action) => {
      state.loading = false;
      state.message = "Product Update successfuly";
    });
    builder.addCase(updateProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
  }
});
export const { clearError, clearMessage } = productSlice.actions;

export default productSlice.reducer;
